export default {"src":"/_next/static/media/arrow.2bf5ade9.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};